module.exports = __webpack_public_path__ + "static/img/day2.2e2a487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/day2.jpg
// module id = WiVA
// module chunks = 0